import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Input';
import { Button } from '../Button';
import styles from './EmailStep.css';

function getButtonLabel(resendCountdown) {
    if (resendCountdown === 0) {
        return 'Continue';
    }

    if (resendCountdown >= 60) {
        return `Get New Code in ${Math.floor(resendCountdown / 60)} min ${resendCountdown % 60} sec`;
    }

    return `Get New Code in ${resendCountdown} sec`;
}

function EmailStep({ fields, errors, isPending, onChange, onSubmit, resendCountdown, otpCountdown }) {
    const isButtonDisabled = resendCountdown > 0 || otpCountdown > 0;
    const buttonLabel = getButtonLabel(resendCountdown);

    return (
        <>
            <Input
                value={fields.email}
                name='email'
                onChange={onChange}
                className={styles.input}
                label='Enter your email address'
                errorText={errors.email || errors.form}
                disabled={isPending}
                inputProps={{ autoComplete: 'email', type: 'email' }}
                alertClassName={styles.inputAlert}
            />
            <Button
                label={buttonLabel}
                onClick={onSubmit}
                className={styles.button}
                isLoading={isPending}
                disabled={isButtonDisabled}
                buttonProps={{ type: 'submit' }}
            />
        </>
    );
}

EmailStep.propTypes = {
    fields: PropTypes.shape({ email: PropTypes.string }).isRequired,
    errors: PropTypes.shape({ email: PropTypes.string, form: PropTypes.string }).isRequired,
    isPending: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    resendCountdown: PropTypes.number,
    otpCountdown: PropTypes.number
};

EmailStep.defaultProps = {
    resendCountdown: 0,
    otpCountdown: 0
};

export {
    EmailStep
};
